export interface IDocumentI18n {
	readonly url: string;
	readonly name: string;
	readonly locale: string;
}

export class DocumentI18n implements IDocumentI18n {
	private _url: string;
	private _name: string;
	private _locale: string;

	constructor(url: string, name: string, locale: string) {
		this._url = url;
		this._name = name;
		this._locale = locale;
	}

	public get url(): string {
		return this._url;
	}

	public get name(): string {
		return this._name;
	}

	public get locale(): string {
		return this._locale;
	}
}
